// The drive is handed every folder at once, each naming its parent, so where a folder sits is
// worked out from that list. The top of the drive holds the folders whose parent isn't listed:
// those in the system's root folder, which is kept out of the list.
import {isFailed, isSecuring} from './fileTools'

// Walks up from the folder to the top, stopping short at a parent that isn't listed.
export const trailTo = (folder, byId) => {
  const trail = []

  for (let current = folder; current; current = byId.get(current.parentId)) trail.unshift(current)

  return trail
}

// "parentId" is null for the top of the drive.
export const isChildOf = (entry, parentId, byId) => (parentId ? entry.parentId === parentId : !byId.has(entry.parentId))

// The folder an item sits in, or null for the top of the drive.
export const placeOf = (parentId, byId) => (byId.has(parentId) ? parentId : null)

// What each listed folder holds, worked out from every file in the place, as Locked hands them all
// over; the drive's folders come with theirs. "size" is in bytes: its own files and those of every
// folder below it, short of files without a size yet, still on their way, or that failed. "busy" is
// whether any of those files is still being secured. "itemCount" is only the folders and files
// directly in it.
export const folderTallies = (folders, uploads, byId) => {
  const tallies = new Map(folders.map(({id}) => [id, {size: 0, itemCount: 0, busy: false}]))
  const countIn = id => {
    if (tallies.has(id)) tallies.get(id).itemCount += 1
  }

  folders.forEach(({parentId}) => countIn(parentId))
  uploads.forEach(file => {
    countIn(file.folderId)

    for (let current = byId.get(file.folderId); current; current = byId.get(current.parentId)) {
      const tally = tallies.get(current.id)

      if (file.filesize && !isFailed(file)) tally.size += file.filesize
      if (isSecuring(file)) tally.busy = true
    }
  })

  return tallies
}
